import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress, Stack, Typography } from '@emburse/embark-core';
function LoadingComponent() {
    return (_jsxs(Stack, { direction: "column", alignItems: "center", justifyContent: "center", spacing: 2, sx: {
            width: '100%',
            height: '100px',
            padding: '20px'
        }, children: [_jsx(CircularProgress, { size: 40 }), _jsx(Typography, { variant: "body2", color: "textSecondary", children: "Loading PDF document..." })] }));
}
export default LoadingComponent;
